import anime from 'animejs'
// import axios from 'axios'
import translate from '../translations'

export default {
  name: 'card-edit-map',

  ui: {
    btEdit: '[js-card-update]',
    btOK: '[js-card-confirm]',
    btDelete: '[js-card-delete]',
    'inputs[]': 'input',
  },

  events: [
    {
      target: 'btEdit',
      on: 'click',
      handle () {
        for (let input of this.ui.inputs) {
          input.disabled = false
        }

        this.ui.btEdit.classList.add('hidden')
        this.ui.btOK.classList.remove('hidden')
      },
    },
    {
      target: 'btOK',
      on: 'click',
      handle (e) {
        let allFilled = true
        for (let input of this.ui.inputs) {
          input.classList.remove('is-error')

          if (
            input.value === '' &&
            input.getAttribute('data-name') !== 'phoneNumber' &&
            input.getAttribute('data-name') !== 'email' &&
            input.getAttribute('data-name') !== 'website'
          ) {
            allFilled = false
            input.classList.add('is-error')
          }
        }

        if (allFilled) {
          const card = this.el // e.currentTarget.closest('.card')
          for (let input of this.ui.inputs) {
            input.disabled = true
          }
          this.ui.btOK.classList.add('hidden')
          this.ui.btEdit.classList.remove('hidden')

          if (this.ui.btOK.classList.contains('create')) {
            card.setAttribute(
              'data-type',
              card.parentNode.parentNode
                .querySelector('.cards-list + .button')
                .getAttribute('data-type')
            )
            // this.request('create', card)
          } /* else {
            this.request('update', card)
          } */
        }
      },
    },
    {
      target: 'btDelete',
      on: 'click',
      handle (e) {
        // const card = e.currentTarget.closest('.card')
        if (confirm(translate('CONFIRM_DELETE'))) {
          anime({
            targets: this.el,
            height: ['185px', '0px'],
            padding: 0,
            easing: 'easeOutSine',
            duration: 300,
            complete: anim => {
              // this.request('delete', card)
              this.el.parentNode.removeChild(this.el)
            },
          })
        } else {
        }

        this.ui.btOK.classList.add('hidden')
        this.ui.btEdit.classList.remove('hidden')
      },
    },
  ],

  /*
  componentDidMount () {
    this.route = this.el.parentNode.parentNode.parentNode.getAttribute(
      'data-route'
    )
    console.log(this.route)
  },

  request (pAction, card) {
    let formData = new FormData()
    formData.append('action', pAction)

    if (pAction === 'update' || pAction === 'delete' || pAction === 'create') {
      formData.append('id', card.querySelector('input[name="id"]').value)
      formData.append('type', card.getAttribute('data-type'))
      formData.append('name', card.querySelector('input[name="name"]').value)
      formData.append(
        'address',
        card.querySelector('input[name="address"]').value
      )
      formData.append(
        'postalCode',
        card.querySelector('input[name="postalCode"]').value
      )
      formData.append('town', card.querySelector('input[name="town"]').value)
      formData.append(
        'country',
        card.querySelector('input[name="country"]').value
      )
      formData.append(
        'phoneNumber',
        card.querySelector('input[name="phoneNumber"]').value
      )
      formData.append('email', card.querySelector('input[name="email"]').value)
      formData.append(
        'website',
        card.querySelector('input[name="website"]').value
      )
    }

    axios
      .post(this.route, formData)
      .then(response => {
        // console.log(response.data)
        if (pAction === 'create') {
          card.setAttribute('data-id', response.data.id)
          this.ui.btOK.classList.remove('create')
        }
      })
      .catch(function (error) {
        // handle error
        console.log(error)
      })
  },
  */
}
